import {
  MessageSquare,    // Conversations
  BarChart3,        // Analytics
  Database,         // Data Agent
  Users,            // Engagements
  Flag,             // Flagged Users
  GitBranch,        // Segregation
  UserCog,          // Admin Users
  Settings,         // Settings
  LogOut,
  Moon,
  Sun,
  UserCircle,       // User Profiles Feed
  LucideIcon
} from 'lucide-react';
import { canManageUsers } from '../utils/permissions';

export interface NavigationItem {
  id: string;
  label: string;
  icon: LucideIcon;
  page: string;
  permission?: (user: any) => boolean;
}

export interface NavigationSection {
  id: string;
  label: string;
  icon: LucideIcon;
  items: NavigationItem[];
  defaultOpen?: boolean;
}

export const NAVIGATION_SECTIONS: NavigationSection[] = [
  {
    id: 'core-features',
    label: 'Core Features',
    icon: MessageSquare,
    defaultOpen: true,
    items: [
      {
        id: 'conversations',
        label: 'Conversations',
        icon: MessageSquare,
        page: 'conversations',
      },
      {
        id: 'analytics',
        label: 'Analytics',
        icon: BarChart3,
        page: 'analytics',
      },
      {
        id: 'user-profiles-feed',
        label: 'User Profiles Feed',
        icon: UserCircle,
        page: 'user-profiles-feed',
      },
    ],
  },
  {
    id: 'user-management',
    label: 'User Management',
    icon: Users,
    defaultOpen: false,
    items: [
      {
        id: 'engagements',
        label: 'Engagements',
        icon: Users,
        page: 'enterprise-engagements',
      },
      {
        id: 'flagged-users',
        label: 'Flagged Users',
        icon: Flag,
        page: 'flagged-users',
      },
      {
        id: 'segregation',
        label: 'Segregation',
        icon: GitBranch,
        page: 'segregation',
      },
    ],
  },
  {
    id: 'tools',
    label: 'Tools',
    icon: Database,
    defaultOpen: false,
    items: [
      {
        id: 'data-agent',
        label: 'Data Agent',
        icon: Database,
        page: 'data-agent',
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: UserCog,
    defaultOpen: false,
    items: [
      {
        id: 'admin-users',
        label: 'User Management',
        icon: UserCog,
        page: 'admin-users',
        permission: canManageUsers,
      },
    ],
  },
];

export const SETTINGS_ITEM: NavigationItem = {
  id: 'settings',
  label: 'Settings',
  icon: Settings,
  page: 'settings',
};

export const THEME_ICONS = {
  Moon,
  Sun,
};

export const LOGOUT_ICON = LogOut;

